'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixStyle;

var _inlineStylePrefixer = require('inline-style-prefixer');

var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixer = new _inlineStylePrefixer2.default();

function prefixStyle(style) {
  return prefixer.prefix(style);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-ios-switch/lib/prefixStyle.js
// module id = 2790
// module chunks = 0